import { DynamicPhoneValidationConfigInput } from '@shared/directives';

export const DYNAMIC_PHONE_DIRECTIVE_CONFIG: DynamicPhoneValidationConfigInput =
  {
    prefix: 'prefixPhone',
    number: 'phoneNumber',
  } as const;
